import EmailAddress from './interfaces/EmailAddress';

export default class User {
	id!: string;

	tenantId!: string;

	department!: {
		id: number;
		name: string;
	};

	surname!: string;

	givenName!: string;

	// eslint-disable-next-line react/static-property-placement
	displayName!: string;

	mailNickname!: string;

	jobTitle!: string;

	telephoneNumber!: string;

	businessPhone!: string;

	eguid!: string;

	email!: EmailAddress;

	userPrincipalName!: EmailAddress;

	dateCreated!: Date;

	lastModified!: Date;

	accountEnabled: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}